import beneficiaryActionStates from "../common/constants/beneficiaryStates";
import beneficiaryDesignationCodes from "../common/constants/beneficiaryDesignationCodes";
import beneficiaryTypeCodes from "../common/constants/beneficiaryTypeCodes";
import beneficiaryRelationshipCodes from "../common/constants/beneficiaryRelationshipCodes";
import maritalStatusCodes from "../common/constants/beneficiaryMaritalStatuses";

var AllocationFactory = function($injector) {
  var factory = {};
  var beneficiaryService = $injector.get('beneficiaryService');
  var translate = $injector.get('$translate');
  var beneficiaryTypeService = $injector.get('beneficiaryTypeService');

  factory.validateAllocations = function(beneficiaries, maritalStatus,hasinvalidDataFlag) {
    var beneficiaryService = $injector.get('beneficiaryService');
    var translate = $injector.get('$translate');
    var errorsPrimary = [];
    var errorsContigent=[];
    var errorsAll=[];
    var valid = true;

    // Check allocations
    var primaryBeneficiaries = 0;
    var primaryAllocationTotal = 0;
    var contingentBeneficiaries = 0;
    var contingentAllocationTotal = 0;
    var hasPrimarySpouse = false;
    var spouseAllocation = 0;
    var zeroAllocationPrimary=false;
    var zeroAllocationContigent= false; 
    var invalidPrimaryRelationship=false;
    var invalidContigentRelationship=false;
    var primaryRelationshipUnknown=false;
    var contigentRelationshipUnknown=false;
    var records = beneficiaryTypeService.getTypes();
    var arr = [];
    angular.forEach(records, function(record) {
        arr.push( record.code);
    });

    var beneKeys = ["Primary", "Contingent"];
    angular.forEach(beneKeys, function (key) {
      angular.forEach(beneficiaries[key], function (beneficiary) {
        // Ignore any beneficiaries that the participant has elected to remove
        if ( beneficiary.beneficiaryState != beneficiaryActionStates.removed ) {

          if (beneficiary.beneficiaryDesignation !== "") {

            if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Primary) {
              if(beneficiary.allocationPercent === 0  || beneficiary.allocationPercent === null || beneficiary.allocationPercent === undefined || beneficiary.allocationPercent.length===0 ){
            	  zeroAllocationPrimary=true;
              }
              	
              
              invalidPrimaryRelationship=!factory.getValidBeneRelationShip(beneficiary.beneficiaryType,arr);
              //over the iteration of the loop the invalidPrimaryRelationship may change in the order of the bene sent
              //if it is set to true once primaryRelationshipUnknown is set to true so that we can check else were outside the loop
              if(invalidPrimaryRelationship){
            	  primaryRelationshipUnknown = true;
              }
   

              if(!zeroAllocationPrimary && !invalidPrimaryRelationship){
                primaryBeneficiaries++;
                primaryAllocationTotal += parseFloat(beneficiary.allocationPercent);

                if (beneficiaryService.getType(beneficiary) == beneficiaryTypeCodes.Individual &&
                    beneficiaryService.getRelationship(beneficiary) == beneficiaryRelationshipCodes.Spouse) {

                  hasPrimarySpouse = true;
                  spouseAllocation += parseFloat(beneficiary.allocationPercent);
                }
              }
            }
            else if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Contingent) {
              
              if(beneficiary.allocationPercent === 0  || beneficiary.allocationPercent === null || beneficiary.allocationPercent === undefined || beneficiary.allocationPercent.length===0){
            	  zeroAllocationContigent= true;
              }
              
              invalidContigentRelationship=!factory.getValidBeneRelationShip(beneficiary.beneficiaryType,arr);
              
              if(invalidContigentRelationship){
            	  contigentRelationshipUnknown = true;
              }
              
              if(!zeroAllocationPrimary && !invalidContigentRelationship){
            	contingentBeneficiaries++;
              contingentAllocationTotal = (parseFloat(contingentAllocationTotal) + parseFloat(beneficiary.allocationPercent)).toFixed(2);
            }
            }   
          }

        }
      });
    });
    if(zeroAllocationPrimary){
      errorsPrimary.push(translate.instant('app.beneficiary.bene.validationMessages.primaryBeneficiaryZeroAllocation'));
    }
    
 /*   if(primaryRelationshipUnknown){
        errorsPrimary.push(translate.instant('app.beneficiary.bene.validationMessages.invalidPrimaryRelationship'));
        }*/

    // Verify that there is at least one Primary beneficiary
    valid = primaryBeneficiaries > 0;
    if ( ! valid ) {
      errorsPrimary.push(translate.instant('app.beneficiary.bene.validationMessages.primaryBeneficiaryRequired'));
    }
    
    // Verify that all Primary beneficiaries add up to 100%
    if ( valid ) {
      valid = primaryAllocationTotal == 100;

      if ( ! valid ) {
        errorsPrimary.push(translate.instant('app.beneficiary.bene.validationMessages.primaryAllocation'));
      }
    }
    if(maritalStatus === null){
    	valid = false;
    }
    //if data is valid this flag is true so inversion
/*    if(hasinvalidDataFlag){
    	valid = false;
    	errorsPrimary.push(translate.instant('app.beneficiary.bene.validationMessages.invalidData'));
    }
*/

    if(zeroAllocationContigent){
    	errorsContigent.push(translate.instant('app.beneficiary.bene.validationMessages.contigentBeneficiaryZeroAllocation'));
    }
    
    if(contigentRelationshipUnknown||primaryRelationshipUnknown || hasinvalidDataFlag){
    	errorsContigent.push(translate.instant('app.beneficiary.bene.validationMessages.invalidContigentRelationship'));
    }

    // Verify that all Contingent beneficiaries add up to 100%
    if ( !contigentRelationshipUnknown && contingentBeneficiaries > 0 && contingentAllocationTotal != 100 ) {
      valid = false;

      errorsContigent.push(translate.instant('app.beneficiary.bene.validationMessages.contingentAllocation'));
    }
    errorsAll.push(errorsPrimary);
    errorsAll.push(errorsContigent);
    return errorsAll;
  }; // validateAllocations()
  
  factory.getValidBeneRelationShip =  function(TypeCode,beneficiaryTypes){

    var foundValidRelationShip =false;
	  angular.forEach(beneficiaryTypes,function(value){
		  if(value == TypeCode){
			  foundValidRelationShip =true;
		  }
		  
	  });
	return foundValidRelationShip;
};
  
  //this is for invalid allocation percentage
  factory.intialPercentagevalidation = function (beneficiaries,startupCheck){
	  var beneKeys = ["Primary", "Contingent"];
	  
	  var invalidallocations = false;
	  var errorsStartUp = [];
	  var blankAllocationPrimary = false;
	  var blankAllocationContigent = false;
	  var primaryBeneficiaries = 0;
	  var primaryAllocationTotal = 0;
	  var contingentBeneficiaries = 0; 
	  var contingentAllocationTotal = 0;
	  if(startupCheck){
	  angular.forEach(beneKeys, function (key) {
		  angular.forEach(beneficiaries[key], function (beneficiary) {
			  if ( beneficiary.beneficiaryState != beneficiaryActionStates.removed ) {

		          if (beneficiary.beneficiaryDesignation !== "") {
		        	  
		        	  if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Primary) {
		        		  primaryBeneficiaries++;
		        		  if (beneficiary.allocationPercent === 0  || beneficiary.allocationPercent === null || beneficiary.allocationPercent === undefined || beneficiary.allocationPercent.length===0){
		        			  blankAllocationPrimary = true;
		        		  }
		        		  else{
                              primaryAllocationTotal = (parseFloat(primaryAllocationTotal) + parseFloat(beneficiary.allocationPercent)).toFixed(2);
		        		  }
		        		  
		        		  
		        		  
		        	  }
		        	  
		        	  if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Contingent) {
		        		  contingentBeneficiaries++;
		        		  if (beneficiary.allocationPercent === 0  || beneficiary.allocationPercent === null || beneficiary.allocationPercent === undefined || beneficiary.allocationPercent.length===0){
		        			  blankAllocationContigent = true;
		        		  }
		        		  else{
                              contingentAllocationTotal = (parseFloat(contingentAllocationTotal) + parseFloat(beneficiary.allocationPercent)).toFixed(2);
		        		  }
		        		}  
		          }
		          
			  }
		  });
	  });
	  if(primaryBeneficiaries>0){
	  if(primaryAllocationTotal != 100 || blankAllocationPrimary){
		  invalidallocations = true;
		  angular.forEach(beneKeys, function (key) {
			  angular.forEach(beneficiaries[key], function (beneficiary) {
				  if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Primary) {
				  beneficiary.allocationPercent = '';
				  }
			  });	
		});
	  }
	 }
	  if(contingentBeneficiaries>0){
	  if(contingentAllocationTotal != 100 || blankAllocationContigent){
		  invalidallocations = true;
		  angular.forEach(beneKeys, function (key) {
			  angular.forEach(beneficiaries[key], function (beneficiary) {
				  if (beneficiary.beneficiaryDesignation == beneficiaryDesignationCodes.Contingent) {
				  beneficiary.allocationPercent = '';
				  }
			  });	
		});	  
	  }
	 }
	  
	  if (invalidallocations){
		  errorsStartUp.push(translate.instant('app.beneficiary.bene.validationMessages.InvalidAllocationsOnImport'));
	  }
	  return errorsStartUp;
  }else{
	  return errorsStartUp;
  }
  };

  return factory;
};

AllocationFactory.$inject = ['$injector'];

export default AllocationFactory;
